import { requestREST } from "~/client/http/CommonHTTP";
import { DealerEpdIProps } from "~/components/Forms/DealerPassportForm2/requests/getEpd";

export const deleteEpd = async (
  dealerId: string,
  epdId: number
): Promise<DealerEpdIProps> => {
  const { data } = await requestREST.delete("/dealer/epd", {
    data: { dealerId: parseInt(dealerId, 10), id: epdId },
  });
  return data;
};
